import { FrameName } from "../config";
import AbstractPoiTileEntity from "./AbstractPoiTileEntity";

class KeepDeserted1PoiTileEntity extends AbstractPoiTileEntity {
	public static readonly frameName = FrameName.KEEP_DESERTED1;
}

export default KeepDeserted1PoiTileEntity;
